//@ts-check
import React from 'react';
import Text from './Text';
import validators from '../../validators';

var EmailField = function EmailField(props) {
  return React.createElement(Text, Object.assign({
    validate: validators.email
  }, props));
};

EmailField.defaultProps = {
  type: 'email'
};
export default EmailField;